import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Notification } from '@layout/notifications/models/notification.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { NotificationSource } from '@layout/notifications/models/notification-source.enum';
import { ZendeskSsoRequestInfo } from '@core/sso/models/zendesk/zendesk-sso-request-info.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly httpClient = inject(HttpClient);

  getNotifications(): Observable<Notification[]> {
    const url = 'api/v1/user/notifications';

    return this.httpClient.post<Notification[]>(environment.portalApiUrl + url, null);
  }

  markAllNotificationsAsRead(): Observable<void> {
    const url = 'api/v1/user/notifications/mark-all-as-read';

    return this.httpClient.post<void>(environment.portalApiUrl + url, null);
  }

  updateNotificationViewability(notificationId: string, source: NotificationSource, viewed: boolean): Observable<void> {
    const url = `api/v1/user/notifications/${notificationId}/viewed`;

    return this.httpClient.put<void>(environment.portalApiUrl + url, { source, viewed });
  }

  deleteNotification(notificationId: string, source: NotificationSource): Observable<void> {
    const url = `api/v1/user/notifications/${notificationId}`;

    return this.httpClient.delete<void>(environment.portalApiUrl + url, { params: { source } });
  }

  deleteAllNotifications(): Observable<void> {
    const url = 'api/v1/user/notifications';

    return this.httpClient.delete<void>(environment.portalApiUrl + url);
  }

  getZendeskSsoRequestInfo(ticketId: string): Observable<ZendeskSsoRequestInfo> {
    const url = `api/v3/zendesk/tickets/${ticketId}/url`;

    return this.httpClient.get<ZendeskSsoRequestInfo>(environment.portalApiUrl + url);
  }

  getUnreadNotificationsCount(): Observable<number> {
    const url = 'api/v1/user/notifications/unread-count';

    return this.httpClient.get<number>(environment.portalApiUrl + url);
  }

  getUserPubSubClientAccessUrl(): Observable<string> {
    const url = 'api/v1/zendesk-notifications/pub-sub-connection';

    return this.httpClient.get(environment.portalApiUrl + url, { responseType: 'text' });
  }
}
